





























import { Vue, Component, Prop } from 'vue-property-decorator';
import ColorPickerButton from '@/components/common/colorpicker/ColorPickerButton.vue';

@Component({
  components: {
    ColorPickerButton,
  },
})
export default class PopupBannerDescription extends Vue {
  @Prop({ default: '' }) private readonly title: string;
  @Prop({ default: '' }) private readonly descriptionData: string;
  @Prop({ default: '#ffffff' }) private readonly defaultColorHexCode: string;
  private temporaryDescriptionData: string = this.descriptionData;
  private colorHexCode: string = this.defaultColorHexCode;

  private onClickSubmit(): void {
    const isValid = this.validation();

    if (isValid) this.onSaveData();
  }

  private onClickCancel(): void {
    this.$emit('onClose');
  }

  private onSaveData() {
    this.$emit('onSubmit', {
      description: this.temporaryDescriptionData,
      colorHexCode: this.colorHexCode,
    });

    this.$emit('onClose');
  }

  // emit chaining
  private onChangeColor(colorHexCode: string): void {
    this.colorHexCode = colorHexCode;
  }

  private validation(): boolean {
    const isEmpty = !this.temporaryDescriptionData.trim();

    if (isEmpty) {
      alert(this.$t('BANNER_LIST_ALERT_EMPTY_CONTENT').toString());
      (this.$refs.bannerDescriptionContentInput as HTMLTextAreaElement).focus();
      return false;
    }

    return true;
  }
}
